import React from 'react'
import ButtonBase from '../ButtonBase'
import './toggleSelector.scss'
import PropTypes from 'prop-types'

const ToggleSelector = ({ value, className, onChange, disabled }) => {
  const circleFill = value ? (disabled ? '#93b3e5' : '#006DC9') : (disabled ? '#F5F5F5' : '#C8C8C8')
  const circleTransform = value ? 'translate(17)' : 'translate(0)'
  const shadowOpacity = value ? 0 : 1
  const railOpacity = value ? (disabled ? 0.4 : 0.8) : 1
  const railFill = value ? '#93b3e5' : (disabled ? '#C8C8C8' : '#E0E0E0')
  return (
        <ButtonBase className={`Suc-toggle-selector ${className}`} disabled={disabled} onClick={() => onChange(!value)} type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="23" viewBox="0 0 40 24">
                <defs>
                    <filter id="prefix__a" width="172.2%" height="172.2%" x="-30.6%" y="-30.6%" filterUnits="objectBoundingBox">
                        <feOffset dx="1" dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
                        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"/>
                    </filter>
                </defs>
                <g fill="none" transform="translate(1 2)">
                    <path className='Suc-toggle-transition' fill={railFill} opacity={railOpacity} d="M6.782 3.5h22.436c3.39-.076 6.202 2.61 6.282 6-.08 3.39-2.891 6.076-6.282 6H6.782C3.392 15.576.58 12.89.5 9.5c.08-3.39 2.891-6.076 6.282-6z"/>
                    <circle className='Suc-toggle-transition' transform={circleTransform} opacity={shadowOpacity} fill="#000" cx="9.5" cy="9.5" r="9" filter="url(#prefix__a)"/>
                    <circle className='Suc-toggle-transition' fill={circleFill} transform={circleTransform} cx="9.5" cy="9.5" r="9"/>
                </g>
            </svg>
        </ButtonBase>
  )
}

ToggleSelector.propTypes = {
  /** toggle state */
  value: PropTypes.bool,
  /** disabled state */
  disabled: PropTypes.bool,
  /** custom classname */
  className: PropTypes.string,
  /** callback called on change */
  onChange: PropTypes.func
}

ToggleSelector.defaultProps = {
  className: '',
  onChange: () => {}
}

export default ToggleSelector
